export default __webpack_public_path__ + "static/media/2.48c9285e.png";